module.exports = __webpack_public_path__ + "static/media/pic2.fd905e0f.jpg";